import {
  addLogoToPdf,
  addQRatAfterTable,
  registerNotoSansFont
} from "helpers";
import { t } from "i18next";
import { jsPDF as JsPDF } from "jspdf";
import { toast } from "react-hot-toast";

import { OrderDetails } from "../../orders.types";
import { getFonts } from "./getFonts";
import { renderDeliveryAndDriver } from "./renderDeliveryAndDriver";
import { renderHeader } from "./renderHeader";
import { renderPages } from "./renderPages";
import { renderPayment } from "./renderPayment";
import { renderProducts } from "./renderProducts";
import { renderTitles } from "./renderTitles";

const downloadOrderPdfAsync = async (
  orders: OrderDetails[]
): Promise<void> => {
  const pdf = new JsPDF({
    unit: "px"
  });

  await registerNotoSansFont(pdf);

  const { normalFontSize, normalFontStyles, bigFontSize, bigFontStyles } =
    getFonts();
  pdf.setLineHeightFactor(1.3);

  orders.forEach((orderDetails, index) => {
    if (index > 0) {
      pdf.addPage();
    }

    if (!orderDetails.isReselling) {
      addLogoToPdf(pdf);
    }

    renderTitles({
      pdf,
      normalFontSize,
      bigFontSize,
      orderDetails
    });
    renderHeader({ pdf, orderDetails, bigFontStyles });
    renderDeliveryAndDriver({
      pdf,
      orderDetails,
      bigFontStyles,
      normalFontStyles
    });
    renderProducts({ pdf, orderDetails, normalFontStyles });
    renderPayment({ pdf, orderDetails, normalFontStyles, bigFontStyles });
    addQRatAfterTable(pdf, `qr-${orderDetails.id}`, {
      width: 150,
      height: 150
    });
  });

  renderPages({ pdf });

  const fileName =
    orders.length === 1 ? `${t("Order")} ${orders[0].id}` : `${t("Orders")}`;

  pdf.save(`${fileName}.pdf`);
};

export const downloadOrderPdf = (orders: OrderDetails[]): void => {
  downloadOrderPdfAsync(orders).catch((err) => {
    console.error("Failed to generate order PDF:", err);
    toast.error(t("Failed to generate PDF"));
  });
};
